import { action } from 'satcheljs';
import TodoFolder from '../store/schema/TodoFolder';

export const processLoadedFolders = action('processLoadedFolders', (folders: TodoFolder[]) => ({
    folders,
}));
